'use client';

import { useLocale } from 'next-intl';
import { useContext, useEffect } from 'react';
import { AppConfigContext } from '@/features/app-providers/app-config-provider';
import { localeToLang } from '@/shared/i18n/localeToLang';
import { syncFirebaseTopics } from '@/shared/lib/firebase-topic';
import { isMobileAppWebView } from '@/shared/lib/mobile-app';

const PLUGIN_POLL_INTERVAL_MS = 250;
const PLUGIN_POLL_ATTEMPTS = 40;

/**
 * Subscribes the whitelabel app's device to the tenant's notification topic. The app injects
 * `window.OrderMagePlugin` only after the page has loaded and announces it with no event, so
 * the bridge is polled for instead of read once on mount.
 */
export const FirebaseTopicHandler = () => {
    const { firebaseTopics } = useContext(AppConfigContext);
    const locale = useLocale();

    useEffect(() => {
        if (!firebaseTopics || !isMobileAppWebView(navigator.userAgent)) {
            return;
        }

        let attempts = 0;
        const interval = setInterval(() => {
            attempts += 1;
            const plugin = window.OrderMagePlugin;
            if (typeof plugin?.subscribeTopic === 'function') {
                clearInterval(interval);
                void syncFirebaseTopics(plugin, firebaseTopics, localeToLang(locale));
            } else if (attempts >= PLUGIN_POLL_ATTEMPTS) {
                clearInterval(interval);
            }
        }, PLUGIN_POLL_INTERVAL_MS);

        return () => clearInterval(interval);
    }, [firebaseTopics, locale]);

    return null;
};
